import { getWechatCode, getOpenIdAndTrackEvent, initConfig, isWechatEnv } from '@/common/weixin.js';

export { getWechatCode, getOpenIdAndTrackEvent, isWechatEnv };

let wxInstance;
let readyPromise = null;

async function ensureWxReady() {
	if (readyPromise) return readyPromise;

	readyPromise = new Promise(async (resolve, reject) => {
		if (typeof window === 'undefined') return resolve();

		try {
			const jweixinModule = await import('jweixin-module');
			let wx = jweixinModule?.default ?? jweixinModule;
			if (typeof wx === 'object' && wx !== null && !wx.ready) {
				const keys = Object.keys(wx);
				wx = keys.length === 1 ? wx[keys[0]] : wx;
			}
			wxInstance = wx;
			if (!wx?.ready) {
				resolve(wx);
				return;
			}
			await initConfig(wx);
			if (!isWechatEnv()) {
				resolve(wx);
				return;
			}
			wx.ready(() => resolve(wx));
			wx.error(err => {
				console.error('微信 SDK 初始化失败:', err);
				reject(err);
			});
		} catch (err) {
			readyPromise = null;
			reject(err);
		}
	});
	return readyPromise;
}

export function useWeixin() {
	async function initWx() {
		await ensureWxReady();
	}

	/** 分享信息已由 useSeoMeta og 标签处理，此方法保留兼容不做操作 */
	async function setShareInfo(_opts = {}) {}

	/**
	 * 页面进入时自动初始化：获取 OpenId + 访问追踪
	 * 分享卡片由 useSeoMeta 的 og:title/og:description/og:image 处理
	 */
	async function autoInit() {
		if (typeof window === 'undefined') return;
		getOpenIdAndTrackEvent().catch(() => {});
	}

	function getWxInstance() {
		return wxInstance;
	}

	return {
		getWxInstance,
		initWx,
		setShareInfo,
		autoInit,
		isWechatEnv,
		getWechatCode,
		getOpenIdAndTrackEvent,
	};
}
